import { render, staticRenderFns } from "./SinglePlayPost.vue?vue&type=template&id=790baa84"
import script from "./SinglePlayPost.vue?vue&type=script&lang=js"
export * from "./SinglePlayPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports